import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import _ from 'underscore';
import { statusConfig } from '../config/status-config';
import { getAgroupitemStyles } from '../styles/adgroup-item-style';

/**
 * adgroup item component for the adgroup selector(single and multi)
 */

const OriginAdgroupItemComponent = (props) => {
  const { item, classes } = props;
  const arrowIconClass = item.isAddedToResultList ? 'disabled' : 'enabled';
  return (
    <div data-id={item.Id} className={classnames('multi-item-container', item.isAddedToResultList ? 'added-to-result-list' : '')}>
      <span className="item-content-parent-info">
        {`${item.campaignName} >`}
      </span>
      <div className="item-content">
        <span className={classnames('statusIcon', _.result(statusConfig, item.status, 'statusEnabled_icon'))} />
        <span className="text" title={item.name}>
          {item.name}
        </span>
      </div>

      {
        item.isShowAddArrow ?
          (<span className={classnames('arrow-button', 'a11y-k-listview-button', arrowIconClass, 'add-arrow-button', classes.addArrowButton)} />) : ''
      }
    </div>
  );
};

OriginAdgroupItemComponent.propTypes = {
  /**
   * JSS injected classes
   */
  classes: PropTypes.objectOf(PropTypes.any).isRequired,

  item: PropTypes.shape({
    /**
     * adgroup status
     */
    status: PropTypes.string.isRequired,
    /**
     * adgroup name
     */
    name: PropTypes.string.isRequired,
    /**
     * campaign name which adgroup belong to
     */
    campaignName: PropTypes.string.isRequired,
    /**
     * adgroup Id
     */
    Id: PropTypes.number.isRequired,
    /**
     * for the multi selector, whether the item added to the result container
     */
    isAddedToResultList: PropTypes.bool,
    /**
     * for the multi selector, adgroup item should show the add arrow
     */
    isShowAddArrow: PropTypes.bool,
  }).isRequired,
};

export const AdgroupItemComponent =
  withDefaultStyles(OriginAdgroupItemComponent, getAgroupitemStyles);
